import { ValueObjectMetadata } from "./get-vo-metadata";

export const isVoStoredInDb = (metadata: ValueObjectMetadata): boolean => {
    return typeof metadata.collection === "undefined" || !!metadata.collection;
}